import React,{ useEffect, useState } from 'react';
import BadgesComponent from '@components/common/Badges';
import './overview.css';
import {  blockList } from '@constants/index';
import { useSelector } from 'react-redux';
import {  useUpperComponent } from '../HealthBlockManagementOverview';
import endpoints from '@config/endpoints';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';
import axios from '@utils/axiosExt';
import Auth from '../../../utils/auth';
import { errorLogger } from '@utils/applicationLogUtils';


interface objectType {
    zoneDivCIr: any;
    flow: string;
}
const ZoneManagementOverview = (props: objectType) => {
    const { zoneDivCIr, flow } = props;
    const { zone_name, type } = zoneDivCIr;
    const [zoneDetails,setZoneDetails]=useState<any>()
    const [districtDetails,setDistrictDetails]=useState<any>()
    const districtByZoneData: any = useSelector((state: any) => state?.GeoNonGeoData?.districtByZone);
    const zoneByZoneId: any = useSelector((state: any) => state?.GeoNonGeoData?.zoneByZoneId);
    const effectiveFromDate = dayjs(zoneDetails?.effective_from_dt).format('DD-MM-YYYY');;
    const stateName=zoneByZoneId?.[zoneDivCIr.id]?.[0]?.state_name;
    const [isLoader,setIsLoader]=useState<boolean>(true)
    const [Component, state] = useUpperComponent();
    const { id } = useParams();
   // let districtData ="";
    
    useEffect(()=>{
        const fetchData=async ()=>{
            try{
                const zoneDetail = await axios.get(`${endpoints.getZoneDivCircleByZDCId(id)}`, Auth.loggedIn());
                const zoneDetails = zoneDetail?.data?.data[0];
                setZoneDetails(zoneDetails)
              }
                catch(error:any){
                    errorLogger(error?.response?.data||error?.response||error)
                }
            try{
                const district = await axios.get(`${endpoints.getDistrictsByZDCId(id)}`, Auth.loggedIn());
              const districts = district?.data?.data;
              const distValue = districts?.map((value: any) => `${value.district_name}-${value.district_code}`).join(', ');
              setDistrictDetails(distValue);

            }
            catch(error:any){
                errorLogger(error?.response?.data||error?.response||error)
            }
              setIsLoader(false)

        }
        fetchData();
    },[])
    const transformDataArray = (dataArray: any) => {
        return dataArray?.length && dataArray?.map((item: any) => {
            const transformedItem: any = {};
            for (const key in item) {
                if (key.startsWith("district_")) {
                    const newKey = key.replace("district_", "");
                    let finalKey = newKey; let value = item[key];
                    if (newKey === "name") {
                        finalKey = "label";
                        value = `${item[key]}-${item['district_code']}`
                    } else if (newKey === "code") {
                        finalKey = "value";
                        value = item[key];
                    }
                    transformedItem[finalKey] = value;
                }

            }
            return transformedItem;
        });
    };

    const districtOptions = transformDataArray(districtByZoneData[zoneDivCIr.id]);
    let typeDetails="Zone Details";
    let typeName="Zone";
    if(zoneDetails?.type_name?.toLowerCase()==="circle"){
        typeDetails="Circle Details";
        typeName="Circle";
    }
    else if(zoneDetails?.type_name.toLowerCase()==="division"){
        typeDetails="Division Details";
        typeName="Division";

    }
    else{
        typeDetails="Zone Details";
        typeName="Zone";

    }
    return (
        <>{isLoader?<div className='loader'>Loading...</div>:<div>

            <div className="overview">
                <BadgesComponent
                    className="over-badge"
                    badgeName={typeDetails}
                    variant="primary-1"
                    badgeType="case5"
                />
                <div className="overview-details">
                    <div>
                        <label className="overview-details-label">Type</label>
                        {<div className="overview-details-value">{
                            zoneDetails?.type_name
                        }</div>}
                    </div>
                    <div>
                        <label className="overview-details-label">{typeName} Name</label>
                        <div className="overview-details-value">{
                            zoneDetails?.zdc_name
                              
                        }</div>
                    </div>
                    <div>
                        <label className="overview-details-label">Effective From Date</label>
                        <div className="overview-details-value">{
                             effectiveFromDate
                        }</div>
                    </div>
                </div>
            </div>
            <div className="overview">
                <BadgesComponent
                    className="over-badge"
                    badgeName="Location details"
                    variant="primary-1"
                    badgeType="case5"
                />
                <div className="overview-details">
                    <div>
                        <label className="overview-details-label">State</label>
                        <div className="overview-details-value">{
                           `${zoneDetails?.state_name}-${zoneDetails?.st_code}`
                               
                        }</div>
                    </div>
                    <div>
                        <label className="overview-details-label">District</label>
                        <div className="overview-details-value">{
                           districtDetails 
                               
                        }</div>
                    </div>
                </div>
            </div>
            </div>}
        </>
    );
};
export default ZoneManagementOverview;
